import type { Styles, Modifiers } from "./types";
import { MODIFIER_SEPARATOR } from "./constants";

export default (styles: Styles, modifiers: Modifiers) =>
  Object.keys(modifiers).reduce((obj: Modifiers, key: string) => {
    const objKey =
      typeof modifiers[key] === "boolean"
        ? key.replace("$", "")
        : [key.replace("$", ""), modifiers[key]].join(MODIFIER_SEPARATOR);

    if (styles[objKey]) {
      obj[styles[objKey]] = Boolean(modifiers[key]);
    }

    return obj;
  }, {});
